export const energyLabels = [
  "A++++",
  "A+++",
  "A++",
  "A+",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
] as const;

export type EnergyLabelValue = (typeof energyLabels)[number];
